module.exports = __webpack_public_path__ + "static/media/040-24 hours.f620faed.svg";